module.exports = __webpack_public_path__ + "img/newLogo.42aa5428.svg";